// The first sign-in's dialogs ("Unlock your earlier messages", 19; "Protect your messages", 38): each
// undecided until its check has run, then coming or not. Home's install card holds meanwhile: at most
// 3 s while undecided, 5 s in all (32, One thing at a time).
import { useEffect, useState, useSyncExternalStore } from 'react';

type Decision = 'undecided' | 'coming' | 'none';
const decisions: Record<'unlock' | 'protect', Decision> = { unlock: 'undecided', protect: 'undecided' };
const listeners = new Set<() => void>();

export function decide(dialog: keyof typeof decisions, decision: Decision): void {
  if (decisions[dialog] === decision) return;
  decisions[dialog] = decision;
  listeners.forEach((l) => l());
}

const state = (): Decision => (Object.values(decisions).includes('coming') ? 'coming' : Object.values(decisions).includes('undecided') ? 'undecided' : 'none');

/** While `on`: a first sign-in dialog is still coming, or undecided for less than 3 s; never past 5 s. */
export function useDialogsAhead(on: boolean): boolean {
  const now = useSyncExternalStore((l) => (listeners.add(l), () => listeners.delete(l)), state);
  const [passed, setPassed] = useState(0);
  useEffect(() => {
    if (!on) return;
    const timers = [3000, 5000].map((ms) => setTimeout(() => setPassed(ms), ms));
    return () => timers.forEach(clearTimeout);
  }, [on]);
  return on && passed < 5000 && (now === 'coming' || (now === 'undecided' && passed < 3000));
}
